import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HomePage from '../components/HomePage';
import { useAuth } from '../contexts/AuthContext';
import { walletService } from '../services/wallet.service';
import LoadingState from '../components/common/LoadingState';

const HomePageWrapper: React.FC = () => {
  const navigate = useNavigate();
  const { user, role } = useAuth();
  const [loading, setLoading] = useState(true);
  const [walletBalance, setWalletBalance] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);

  const userName =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : user?.phoneNumber ?? 'کاربر';

  useEffect(() => {
    const load = async () => {
      try {
        const balance = await walletService.getBalance();
        setWalletBalance(balance.available);
        setNotificationCount(3);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  if (loading) return <LoadingState />;

  return (
    <HomePage
      userName={userName}
      walletBalance={walletBalance}
      notificationCount={notificationCount}
      userRole={role}
      onNotificationClick={() => navigate('/notifications')}
      onQuickAction={(action) => {
        const map: Record<string, string> = {
          reservation: '/bookings',
          trip: '/trips',
          wallet: '/wallet',
          notification: '/notifications',
          requests: '/bookings',
          trips: '/trips',
        };
        const path = map[action];
        if (path) navigate(path);
      }}
    />
  );
};

export default HomePageWrapper;
